import React, { ReactNode } from 'react';
import { MenuIcon, ProfileIcon } from './Icons';

export interface MobileHeaderProps {
  onMenuClick?: () => void;
  onProfileClick?: () => void;
  title?: ReactNode;
  leftAction?: ReactNode;
  rightAction?: ReactNode;
  showMenuButton?: boolean;
  showProfileButton?: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuClick,
  onProfileClick,
  title,
  leftAction,
  rightAction,
  showMenuButton = true,
  showProfileButton = true,
}) => {
  return (
    <nav className="navbar min-h-16 px-4">
      <div className="navbar-start">
        {leftAction ? (
          leftAction
        ) : showMenuButton ? (
          <button onClick={onMenuClick} className="btn btn-ghost btn-circle" aria-label="Open menu">
            <MenuIcon className="h-5 w-5" />
          </button>
        ) : null}
      </div>

      <div className="navbar-center">
        {title && <div className="text-base font-medium">{title}</div>}
      </div>

      <div className="navbar-end">
        {rightAction ? (
          rightAction
        ) : showProfileButton ? (
          <button
            onClick={onProfileClick}
            className="btn btn-ghost btn-circle"
            aria-label="Open profile"
          >
            <ProfileIcon className="h-5 w-5" />
          </button>
        ) : null}
      </div>
    </nav>
  );
};
